const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

/**
 * Removes UTM parameters from the current URL.
 */
function removeUTMParamsFromURL() {
  const url = new URL(window.location.href);
  UTM_KEYS.forEach((key) => url.searchParams.delete(key));
  const cleanUrl = url.toString().replace(/([&?])$/, '');
  window.history.replaceState({}, document.title, cleanUrl);
}

/**
 * Handles UTM parameters by storing them in local storage and removing them from the URL.
 */
function handleUTMParams() {
  const urlParams = new URLSearchParams(window.location.search);
  UTM_KEYS.forEach((key) => {
    const value = urlParams.get(key);
    if (value) localStorage.setItem(key, value);
  });
  removeUTMParamsFromURL();
}

/**
 * Retrieves UTM parameters from local storage.
 */
function getUTMParams() {
  const params = {};
  UTM_KEYS.forEach((key) => {
    const value = localStorage.getItem(key);
    if (!value) return;
    const keyWithoutUtm = key.replace('utm_', '');
    params[keyWithoutUtm] = value;
  });
  return params;
}

/**
 * Removes UTM parameters from local storage.
 */
function removeUTMParamsFromLocalStorage() {
  UTM_KEYS.forEach((key) => localStorage.removeItem(key));
}

export default {
  handleUTMParams,
  getUTMParams,
  removeUTMParamsFromLocalStorage,
};
